/**
 * The Ballast (Act II) — a positional gravity well. Nudges a projectile's
 * velocity toward `(cx, cy)` by `strength` px/s while it's within `radius`,
 * bending its flight path. Applied every frame to BOTH pools (boss bullets and
 * the player's own shots — Game._applyBallast), which is the whole signature:
 * you fire straight and watch your shots pull wide, and rings fired outward
 * curve back in.
 *
 * Kept as a pure function (no Game/canvas coupling) so the physics is unit-
 * testable on plain `{x, y, vx, vy}` objects. Orbit-driven projectiles (Orbit
 * Ward) compute position from their orbit center rather than vx/vy, so nudging
 * their velocity is a harmless no-op — no need to special-case them.
 *
 * Returns true if the well acted on the projectile (in range), false otherwise.
 */
export function applyGravityWell(proj, cx, cy, strength, radius, dt) {
  const dx = cx - proj.x;
  const dy = cy - proj.y;
  const dist = Math.hypot(dx, dy);
  if (dist < 1 || dist > radius) return false;
  // Unit vector toward the center × strength × dt → constant inward pull.
  const a = (strength * dt) / dist;
  proj.vx += dx * a;
  proj.vy += dy * a;
  return true;
}
